import * as Sentry from '@sentry/browser';

Sentry.init({
  dsn: 'https://a96fcf01a244954839fd09e92237dc14@o4507544538447872.ingest.us.sentry.io/4507544648089600',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.thirdPartyErrorFilterIntegration({
      filterKeys: ["mingle"],
      behaviour: "drop-error-if-contains-third-party-frames",
    }),
  ],
  sampleRate: 0.5,
  tracesSampleRate: 0.3,
});
